import React, { useEffect } from "react";
import Typography from "@mui/material/Typography/Typography";
import makeStyles from "@mui/styles/makeStyles/makeStyles";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import {
  ButtonComponent,
  GenericDialogComponent,
  InputComponent,
} from "../../../../../components";
import { useDialog } from "../../../../../providers";

const useStyles = makeStyles(() => ({
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "1vh",
    marginBottom: "2vh",
  },
}));

const AdminBankFormDialogComponent = ({ onCreate, onEdit }) => {
  const { metadata: bank } = useDialog();
  const classes = useStyles();
  const schema = yup.object().shape({
    name: yup.string().required("Campo obrigatório"),
    number: yup.string().required("Campo obrigatório"),
  });

  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      name: "",
      number: "",
    },
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (!!bank) {
      reset({ name: bank.name, number: bank.number });
    } else {
      reset({ name: "", number: "" });
    }
  }, [bank]);

  const onSubmit = handleSubmit(({ name, number }) => {
    if (!!bank) {
      onEdit({ id: bank.id, name: name, number: number });
    } else {
      onCreate({ name: name, number: number });
    }
  });

  return (
    <GenericDialogComponent name="admin-bank-form-dialog">
      <form onSubmit={onSubmit} className={classes.content}>
        <Typography
          style={{
            marginBottom: "2vh",
            fontWeight: "700",
            fontSize: "1.95vh",
            color: "#40215F",
          }}
        >
          {!!bank ? "EDITAR" : "CADASTRAR"} BANCO
        </Typography>

        <InputComponent
          name="name"
          placeholder="NOME DO BANCO"
          control={control}
        />

        <div style={{ marginTop: "2vh" }}></div>

        <InputComponent name="number" placeholder="NÚMERO" control={control} />

        <div
          style={{
            marginTop: "4vh",
            display: "flex",
            width: "100%",
            justifyContent: "end",
          }}
        >
          <div style={{ marginLeft: "2vw" }}>
            <ButtonComponent
              label={!!bank ? "EDITAR" : "CADASTRAR"}
              backgroundColor="#40215F"
              color="white"
              size="small"
              height="5vh"
              type="submit"
            />
          </div>
        </div>
      </form>
    </GenericDialogComponent>
  );
};

export default AdminBankFormDialogComponent;
